import {
  type CreateLanguageRequest,
  type LanguageDetail,
  LanguageDetailSchema,
  type LanguageListQuery,
  type LanguageListResponse,
  LanguageListResponseSchema,
  type UpdateLanguageRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

export const listLanguages = async (query: LanguageListQuery): Promise<LanguageListResponse> => {
  const { data } = await apiClient.get<unknown>('/languages', { params: query });
  return LanguageListResponseSchema.parse(data);
};

export const getLanguage = async (id: string): Promise<LanguageDetail> => {
  const { data } = await apiClient.get<unknown>(`/languages/${id}`);
  return LanguageDetailSchema.parse(data);
};

export const createLanguage = async (payload: CreateLanguageRequest): Promise<LanguageDetail> => {
  const { data } = await apiClient.post<unknown>('/languages', payload);
  return LanguageDetailSchema.parse(data);
};

export const updateLanguage = async (
  id: string,
  payload: UpdateLanguageRequest,
): Promise<LanguageDetail> => {
  const { data } = await apiClient.patch<unknown>(`/languages/${id}`, payload);
  return LanguageDetailSchema.parse(data);
};

export const deleteLanguage = async (id: string): Promise<void> => {
  await apiClient.delete(`/languages/${id}`);
};

export const bulkDeleteLanguages = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/languages/bulk-delete', { ids });
  return data;
};

export const bulkSetLanguagesStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/languages/bulk-set-status', { ids, isActive });
  return data;
};
